export const MENUITEMS = [
  {
    menutitle: 'Menu',
  },
    {
    path: `${import.meta.env.BASE_URL}dashboard`,
    title: 'Dashboard',
    icon: <i className="bx bx-chart side-menu__icon"></i>,
    type: 'link',
    selected: false,
    dirchange: false,
    active: false,
    key: 'pulseDashboard',
  },
  {
    title: 'User Management',
    icon: <i className="bx bx-user side-menu__icon"></i>,
    type: 'sub',
    selected: false,
    dirchange: false,
    active: false,
    pulseAdmin: true,
    children: [
      {
        path: `${import.meta.env.BASE_URL}users`,
        title: 'Users',
        type: 'link',
        active: false,
        selected: false,
        dirchange: false,
        key: 'accountsPulse',
      },
      {
        path: `${import.meta.env.BASE_URL}roles`,
        title: 'Roles',
        type: 'link',
        active: false,
        selected: false,
        dirchange: false,
        key: 'accountsPulse',
      },
    ],
  },
  {
    title: 'App Orders',
    icon: <i className="bx bx-building side-menu__icon"></i>,
    type: 'sub',
    selected: false,
    dirchange: false,
    active: false,
    children: [
      {
        path: `${import.meta.env.BASE_URL}orderManagement`,
        title: 'Order Management',
        type: 'link',
        active: false,
        selected: false,
        dirchange: false,
        key: 'appOrdersPulse.order.details',
      },
      {
        path: `${import.meta.env.BASE_URL}deliveryConfig`,
        title: 'Delivery Updates',
        type: 'link',
        active: false,
        selected: false,
        dirchange: false,
        key: 'appOrdersPulse.deliveryUpdate',
      }
   
    ],
  },
  {
    title: 'Availability',
    icon: <i className="bi bi-cart-check-fill side-menu__icon"></i>,
    type: 'sub',
    selected: false,
    dirchange: false,
    active: false,
    children: [
      {
        path: `${import.meta.env.BASE_URL}store`,
        title: 'Stores',
        type: 'link',
        active: false,
        selected: false,
        dirchange: false,
        key: 'availability.store',
      },
      {
        path: `${import.meta.env.BASE_URL}modifiers`,
        title: 'Modifiers',
        type: 'link',
        active: false,
        selected: false,
        dirchange: false,
        key: 'availability.modifier',
      },
      {
        path: `${import.meta.env.BASE_URL}menu`,
        title: 'Menu',
        type: 'link',
        active: false,
        selected: false,
        dirchange: false,
        key: 'availability.menu',
      },
    ],
  },
]
